<template>
  <div>
    <module-container :title="title">
      <AlgorithmConfig
        ref="algorithmConfig"
        @typeBtnChange="handleTypeBtnChange"
        :show-quick-choose="false"
      />
      <PushSettings
        ref="pushSettings"
        :task-type="taskType"
        :show-import-scholar="false"
        :show-send-author-count="pushType === 8"
        :default-push-type="pushType"
      />
      <div class="action-buttons">
        <!-- <div class="rule-select" v-if="isCluster">
          <label>规则用途：</label>
          <el-select v-model="selectType">
            <el-option label="推送筛选" value="1"></el-option>
            <el-option label="效果对比" value="2"></el-option>
          </el-select>
        </div> -->
        <el-button type="primary" @click="save" :loading="submitLoading"
          >保存</el-button
        >
      </div>
    </module-container>
  </div>
</template>

<script>
import ModuleContainer from '@comp/moduleContainer'
import AlgorithmConfig from '@/components/shortcut/algorithmConfig.vue'
import PushSettings from './components/PushSettings.vue'
import { mapGetters } from 'vuex'
export default {
  name: 'ScholarPanel',
  components: {
    ModuleContainer,
    AlgorithmConfig,
    PushSettings
  },
  data() {
    return {
      submitLoading: false,
      selectType: '1',
      taskType: '',
      pushType: '',
      btnList: [
        {
          text: '普通推送',
          id: 10
        },
        {
          text: '白名单推送',
          id: 11
        },
        {
          text: '智能推送',
          id: 8
        }
      ]
    }
  },
  computed: {
    ...mapGetters(['isCluster', 'isMedicalAssociationEnv']),

    title() {
      return this.btnList.find((item) => item.id === this.pushType)?.text
    }
  },
  created() {
    this.taskType = this.$route.query.type || ''
  },
  methods: {
    handleTypeBtnChange(item) {
      this.pushType = item
    },
    // 校验论文范围是否为空
    validatePaperRange() {
      // 快捷方式组件不可见时跳过校验
      if (!this.isMedicalAssociationEnv) {
        return true
      }
      if (!this.$refs.algorithmConfig) return true
      const invalidName = this.$refs.algorithmConfig.validatePaperRange()
      if (invalidName) {
        this.$message({
          message: `${invalidName}论文范围为必选！`,
          duration: 3000,
          type: 'error'
        })
        return false
      }
      return true
    },
    save() {
      if (!this.validatePaperRange()) return
      // 提交推送设置表单
      // 保存快捷方式配置
      let promiseArr = [
        this.$refs.pushSettings.submitForm(),
        this.$refs.algorithmConfig.setCustomScholar()
      ]
      this.submitLoading = true
      Promise.all(promiseArr)
        .then((res) => {
          console.log(res, '保存快捷方式配置')
          this.$message({
            type: 'success',
            message: '保存成功'
          })
          if (res && res[1]) {
            const query = { ...this.$route.query }
            if (res[1] !== undefined) {
              query.pushType = res[1]
            }
            this.$router.replace({ query })
          }
        })
        .finally(() => {
          this.submitLoading = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.action-buttons {
  display: flex;
  justify-content: center;
  padding: 30px;
  gap: 20px;
}
.rule-select {
  label {
    font-size: 12px;
  }
}
</style>
